import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { ITicketChannelAction } from '../../../../models/ticket';
import { TicketActionAttachmentTypes, StateTypes } from '../../../../common/enums';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import { UserCompactInfo } from '../../../../models/user';
import * as _ from 'lodash';
import { namespace } from 'vuex-class';
import { TICKET_MODULE_NAMESPACE, TICKET_LOADERS } from '../../../../store/ticket';



const TicketStore= namespace(TICKET_MODULE_NAMESPACE)

@Component({
  components: {
    'message-item': async () => import('../ticket-chat-message-item/TicketChatMessageItem.vue'),
    'message-request-quote': async () => import('../ticket-chat-message-request-quote-item/TicketChatMessageRequestQuoteItem.vue'),
    'message-seperator': async () => import('../ticket-chat-message-item-seperator/TicketChatMessageItemSeperator.vue'),
    'message-file-uploading': async () => import('../ticket-chat-message-uploading/TicketChatMessageUploading.vue'),
    'chat-message-loader': async () => import('../../loaders/ticket-chat-content-loader/TicketChatContentLoader.vue')
  }
})
class TicketChatMessage extends Vue {
  dtStyle: { width: string; height: string } | null;
  dtPreviousDate?: string | null;
  dtOffsetY: number | null;
  $refs: { scroller: { scrollTop: number, scrollHeight: number, clientHeight: number } } | any

  private _clearTimeout: any;
  private dtPreviousScrollTop: number | null;
  /**
   *
   */
  constructor() {
    super();
    this.dtStyle = null;
    this.dtOffsetY = null;
    this.dtPreviousScrollTop = 0;
    this.dtPreviousDate = DateTimeHelper.parseDate(this.ticketDate);
  }

  @TicketStore.Getter loaders: Map<string,boolean>

  get coPreviousDate(): string {
    return this.dtPreviousDate;
  }
  set coPreviousDate(value: string) {
    this.dtPreviousDate = value;
  }
  get coLoader(): boolean {
    return this.loaders.get(TICKET_LOADERS.CHAT_CONTENT)
  }
  get lblSetting() {
    return require('../../../../locales/ticket').default
  }
  @Prop({ default: null, type: [String] })
  ticketDate: string;
  @Prop({ default: () => [], type: [Array] })
  source: any[];
  @Prop({ default: () => [], type: [Array] })
  news: any[];

  @Prop({ default: () => [], type: [Array] })
  filesUploading: any[];

  @Prop({ default: false, type: [Boolean] })
  isOwner: boolean;

  get coActions() {
    this.handleScroll(true);
    this.coPreviousDate = DateTimeHelper.parseDateWithoutTimezone(this.ticketDate);
    const orderSource = this.source.concat(this.news)
    return _.orderBy(orderSource, ['createdAt'], ['asc']).map((x, index, items) => this.mapMessage(x, index, items).next().value)
  }
  private *mapMessage(item, index: number, items) {

    // const closed: boolean = item.action_type === StateTypes.Close;
    // item['isClose'] = closed
    if (index !== 0) {

      const previousDate = items[index - 1].createdAt.substring(0, 10);
      const currentDate = items[index].createdAt.substring(0, 10);

      // if (previousDate !== currentDate || closed) {
      if (previousDate !== currentDate) {

        item.owner = {
          firstname: item.actor.entity.firstname,
          lastname: item.actor.entity.lastname,
          date: DateTimeHelper.parseLongDateWithouUtc(item.createdAt, this.$i18n.locale.substr(0, 2))
        };
      }
    }

    yield item;
  }
  get coContainerColor(): string {
    return this.isOwner ? 'primary' : 'white';
  }
  get coTextColor(): string {
    return this.isOwner ? 'white--text' : 'primary--text';
  }
  get coStyle() {
    return {
      width: '100%',
      height: `calc(100vh - ${300 + (this.isOwner ? 10 : 0)}px)`
    }
  }

  @Emit('open-modal')
  handleConfirmModal() {
  }

  isMessage(action: ITicketChannelAction) {
    return (action.action_type === TicketActionAttachmentTypes.Message
      || action.action_type === TicketActionAttachmentTypes.Attachment
      || action.action_type === TicketActionAttachmentTypes.Loader
      || action.action_type === TicketActionAttachmentTypes.Loader_indeterminate
      || action.action_type === TicketActionAttachmentTypes.Error
    );

  }

  isUploading(action: { loader_id: string, id: number }) {
    return action.loader_id && action.id === undefined
  }
  checkEqual(date: string, index: number) {

    if (index === this.coActions.length - 1) return false;

    const parsedDate: string = DateTimeHelper.parseDate(date);
    const notEqual: boolean = this.coPreviousDate !== parsedDate;

    if (notEqual) {
      this.coPreviousDate = parsedDate;
      return notEqual;
    }
    return false;
  }
  getDate = (date: string) => {
    return DateTimeHelper.parseDateWithoutTimezone(date)
  };


  handleScroll(event) {
    if (event === true) {
      clearTimeout(this._clearTimeout)
      this._clearTimeout = setTimeout(() => {
        try {
          if (event === true) {
            this.$refs.scroller.scrollTop = this.$refs.scroller.scrollHeight - this.$refs.scroller.clientHeight;
          }
        } catch (error) {
          console.log(error, 'error when scroll')
        }
      }, 300);
    }
    else if (event) {

      const seperators = document.getElementsByClassName('seperator') as any;
      if (seperators.length === 0) return;
      const mainSeperator = document.getElementsByClassName('main-seperator')[0];
      const header = document.getElementById('conversation-header');
      const label = document.getElementById('seperator-text');
      const offsetY: number = this.$refs.scroller.scrollTop + header.offsetHeight + header.offsetTop;

      for (let i = 0; i < seperators.length; i++) {
        if ((offsetY < seperators[i].offsetTop && i === 0)) {
          label.textContent = mainSeperator.classList[mainSeperator.classList.length - 1];
        }
        else if (i <= seperators.length - 2) {
          if (offsetY > seperators[i].offsetTop && offsetY <= seperators[i + 1].offsetTop) {

            label.textContent = seperators[i].id;
          } else if (offsetY > seperators[i].offsetTop && i === seperators.length - 2)
            label.textContent = seperators[i + 1].id;
        } else if (offsetY > seperators[i].offsetTop && seperators.length === 1) {
          label.textContent = seperators[i].id;
        }
      }
    }
  }

  // isClose({ action_type }) {
  //   return action_type === StateTypes.Close;
  // }

  visible(action: { isSeperator: boolean, action_type: string, createdAt: string }, index: number) {

    if (index === 0) return false;
    else if (action.action_type === StateTypes.Close) {
      return true;
    } else {
      const previousDate: string = this.coActions[index - 1].createdAt.substring(0, 10);
      const currentDate: string = action.createdAt.substring(0, 10);
      return previousDate !== currentDate;
    }

  }
  isStatement(action: { action_type: string }) {
    const matched: boolean = action.action_type === StateTypes.Open
      || action.action_type === StateTypes.ReOpen
      || action.action_type === StateTypes.Close
      || action.action_type === StateTypes.Join
      || action.action_type === StateTypes.JoinChannel
      || action.action_type === StateTypes.NewGroup
      || action.action_type === StateTypes.QuitChannel
      || action.action_type === StateTypes.RemoveIc
      || action.action_type === StateTypes.CloseChannel
      || action.action_type === StateTypes.ReopenChannel
      || action.action_type === StateTypes.AppointmentConfirm
      || action.action_type === StateTypes.AppoinmentAsk
      || action.action_type === StateTypes.AppoinmentReject
      || action.action_type === StateTypes.AppoinmentCancel
      || action.action_type === StateTypes.AppoinmentUpdate
      || action.action_type === StateTypes.AppoinmentDone
      || action.action_type === StateTypes.InterventionReport
      || action.action_type === StateTypes.UpdateTicket
      || action.action_type.indexOf('request') > -1;
    return matched;
  }
  getFullName(obj: any): string {
    if (obj)
      return new UserCompactInfo(obj).fullName;
    return obj;
  }
  handleResend(event) {
    this.$emit('resend', event)
  }
  mounted() {
    this.$watch('filesUploading', (value) => {
      if (value.length > 0) {
        this.handleScroll(true)
      }
    })
  }
}

export default TicketChatMessage;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-chat-message/index.ts